import React, { createContext, useEffect, useMemo, useReducer } from "react";
import { TITLE } from "../databases/spName";
import { QueryDisabledHidden } from "../databases/locks";

export const SettingContext = createContext({});

const initialRound =   {
    'flightIndex' : {
      disabled : false,
      hidden : false,
    }, 
    'nameTitle' : {
      disabled : false,
      hidden : false,
    }, 
    'nameEN' : {
      disabled : false,
      hidden : false,
    }, 
    'nameCN' : {
      disabled : false,
      hidden : false,
    }, 
    'nameTitleTH' : {
      disabled : false,
      hidden : false,
    }, 
    'nameTH' : {
      disabled : false,
      hidden : false,
    }, 
    'passport' : {
      disabled : false,
      hidden : false,
    }, 
    'nation' : {
      disabled : false,
      hidden : false,
    }, 
    'birth' : {
      disabled : false,
      hidden : false,
    }, 
    'seatType' : {
      disabled : false,
      hidden : false,
    }, 
    'visa' : {
      disabled : false,
      hidden : false,
    },
    'school' : {
      disabled : false,
      hidden : false,
    }, 
    'province' : {
      disabled : false,
      hidden : false,
    }, 
    'degree' : {
      disabled : false,
      hidden : false,
    }, 
    'year' : {
      disabled : false,
      hidden : false,
    }, 
    'major' : {
      disabled : false,
      hidden : false,
    }, 
    'endYear' : {
      disabled : false,
      hidden : false,
    }, 
    'dose' : {
      disabled : false,
      hidden : false,
    }, 
    'telephone' : {
      disabled : false,
      hidden : false,
    }, 
    'emergency' : {
      disabled : false,
      hidden : false,
    }, 
    'lineID' : {
      disabled : false,
      hidden : false,
    }, 
    'wechatID' : {
      disabled : false,
      hidden : false,
    }, 
    'food' : {
      disabled : false,
      hidden : false,
    }, 
    'pp' : {
      disabled : false,
      hidden : false,
    },
    'cov1' : {
      disabled : false,
      hidden : false,
    },
    'cov2' : {
      disabled : false,
      hidden : false,
    },
    'cov3' : {
      disabled : false,
      hidden : false,
    },
    'cov4' : {
      disabled : false,
      hidden : false,
    },
    'hcode' : {
      disabled : false,
      hidden : false,
    },
    'othdoc' : {
      disabled : false,
      hidden : false,
    },
    "addressTHNo": {
      "disabled": false,
      "hidden": false
    },
    "addressTHBuilding": {
      "disabled": false,
      "hidden": false
    },
    "addressTHFloor": {
      "disabled": false,
      "hidden": false
    },
    "addressTHVillage": {
      "disabled": false,
      "hidden": false
    },
    "addressTHVillageNo": {
      "disabled": false,
      "hidden": false
    },
    "addressTHAlley": {
      "disabled": false,
      "hidden": false
    },
    "addressTHLane": {
      "disabled": false,
      "hidden": false
    },
    "addressTHRoad": {
      "disabled": false,
      "hidden": false
    },
    "addressTHSubDistrict": {
      "disabled": false,
      "hidden": false
    },
    "addressTHDistrict": {
      "disabled": false,
      "hidden": false
    },
    "addressTHProvince": {
      "disabled": false,
      "hidden": false
    },
    "addressTHPostal": {
      "disabled": false,
      "hidden": false
    },
    "addressCNSheng": {
      "disabled": false,
      "hidden": false
    },
    "addressCNChengshi": {
      "disabled": false,
      "hidden": false
    },
    "addressCNQv": {
      "disabled": false,
      "hidden": false
    },
    "addressCNDizhi": {
      "disabled": false,
      "hidden": false
    },
    nickName : {
      "disabled": false,
      "hidden": false
    },
    telCN : {
      "disabled": false,
      "hidden": false
    },
    passportExpiredDate : {
      disabled : false,
      hidden : false,
    },
    schoolCity : {
        disabled : false,
        hidden : false,
    },
    dose1 : {
      disabled : false,
      hidden : false,
    },
    dose2 : {
        disabled : false,
        hidden : false,
    },
    dose3 : {
        disabled : false,
        hidden : false,
    },
    dose4 : {
        disabled : false,
        hidden : false,
    },
    dose5 : {
        disabled : false,
        hidden : false,
    },
    dose6 : {
        disabled : false,
        hidden : false,
    },
    dose7 : {
        disabled : false,
        hidden : false,
    },
    dose8 : {
        disabled : false,
        hidden : false,
    },
    doseLatestDate : {
        disabled : false,
        hidden : false,
    },
}

const initialState = {
    //disabledHiddenList : {}
    disabledHiddenList : [...Object.keys(TITLE.round.options)].map(v => String(v)).reduce((prev, curr) => ({...prev, [curr] : {...initialRound}}), {})
}



const reducer = (state, action) => {
    switch (action.type) {
        case "SET_DISABLE_HIDDEN":
            return {...state, disabledHiddenList : action.payload}
        default:
            break;
    }
}

export const SettingProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState)
    const { disabledHiddenList } = state;
    const setDisabledHiddenList = payload => dispatch({ type: 'SET_DISABLE_HIDDEN', payload });

    useEffect(() => {
        
        const unsub = QueryDisabledHidden(setDisabledHiddenList)
        return () => {
            unsub()
            setDisabledHiddenList({...initialState.disabledHiddenList})
        }
    }, [])

    /*const disabledHiddenOption = useMemo(() => {
      console.log(disabledHiddenList)
      return [...Object.keys(disabledHiddenList)]
    }, [disabledHiddenList])*/
    //console.log(disabledHiddenList)

    
    
    return (
        <SettingContext.Provider value={useMemo(() => ({ disabledHiddenList }), [disabledHiddenList])}>
            {children}
        </SettingContext.Provider>
    )
}